import { render, staticRenderFns } from "./SModalStemdoerNotAvailable.vue?vue&type=template&id=0a8b637d&scoped=true"
import script from "./sModalStemdoerNotAvailable.ts?vue&type=script&lang=ts&external"
export * from "./sModalStemdoerNotAvailable.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalStemdoerNotAvailable.vue?vue&type=style&index=0&id=0a8b637d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b637d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8b637d')) {
      api.createRecord('0a8b637d', component.options)
    } else {
      api.reload('0a8b637d', component.options)
    }
    module.hot.accept("./SModalStemdoerNotAvailable.vue?vue&type=template&id=0a8b637d&scoped=true", function () {
      api.rerender('0a8b637d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-modal-stemdoer-not-available/SModalStemdoerNotAvailable.vue"
export default component.exports